/**
 * Formats a duration in minutes to human-readable string.
 * Examples: 12 → "12min", 72 → "1h 12min", 120 → "2h"
 */
export function formatDuration(minutes: number): string {
  const total = Math.round(minutes);
  if (total < 60) return `${total}min`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}
